export const priceCodeOptions = [
  { value: '1', label: 'Unleaded E10' },
  { value: '2', label: 'Unleaded 91' },
  { value: '3', label: 'Premium 95' },
  { value: '4', label: 'Premium 98' },
  { value: '5', label: 'Diesel' },
  { value: '6', label: 'Premium Diesel' },
  { value: '7', label: 'Ad Blue' },
  { value: '8', label: 'LPG' },
];

export const priceCodeOptionsMap = priceCodeOptions.reduce(
  (acc, cur) => ({ ...acc, [cur.value]: cur.label }),
  {},
);
